<template>
    <div>
        <div class="form-group">
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <select v-model="pass.color" 
                    :disabled="isLoading"
                    :class="['input-group-text', pass.color]">
                        <option class="dropdown-item" value="grey" >Grijs</option>
                        <option class="dropdown-item" value="green" >Groen</option>
                        <option class="dropdown-item" value="blue" >Blauw</option>
                        <option class="dropdown-item" value="orange" >Oranje</option>
                        <option class="dropdown-item" value="yellow" >Geel</option>
                    </select>
                </div>
                <div class="custom-file">
                    <input type="file" id="pass" name="pass" 
                    :disabled="isLoading"
                    :class="['custom-file-input form-control', ($v.pass.document.$dirty) ? ($v.pass.document.$error) ? 'is-invalid' : 'is-valid' : '']" 
                    @change="add($event)">
                    <label class="custom-file-label ellipsis" for="pass">{{pass.name}}</label>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <div class="col-md-3" v-for="p in passArray" :key="p.name">
                <pass :pass="p" @remove="remove" :removeable="removeable"></pass>
            </div>
            <div class="col-md-3 text-center mt-5" v-if="isLoading">
                <loader width="5rem"></loader>
                <h5 class="mt-3 ellipsis">Bezig met pas validatie...</h5>
            </div>
        </div>
        <vue-toastr ref="toastr"></vue-toastr>
    </div>
</template>

<script>
import VueToastr from "vue-toastr";
import Pass from '@/components/Pass'
import Loader from '@/components/Loader'
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'

const fileValidation = (value) => 
{
    if(value != null)
    {
        const ext = value.name.split(".")[value.name.split(".").length - 1];
        const extentions = ['doc', 'docx', 'pdf', 'jpg', 'png', 'jpeg'];
        return value.size <= 4000000 && extentions.indexOf(ext.toLowerCase()) >= 0;
    }
    return true;
}

export default {
    name: 'pass-manager',
    mixins: [validationMixin],
    components: {
        Pass,
        Loader,
        VueToastr
    },
    props: {
        passes: {
            type: Array
        },
        save: {
            type: Boolean,
            default: false
        },
        removeable: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            isLoading: false,
            passArray: this.passes,
            pass: {
                name: "Kies een document...",
                color: "grey",
                document: null
            }
        }
    },
    mounted() {
        this.$refs.toastr.defaultPosition = "toast-bottom-right";
    },
    methods: {
        add(ev) {
            if(!this.$v.pass.$invalid && ev.currentTarget.files.length > 0)
            {
                this.isLoading = true;

                let file = ev.currentTarget.files[0];
                let formData = new FormData();
                formData.append(this.pass.color + "_pass", file);
                return this.$http.post('api/Pass/' + this.pass.color + "?save=" + this.save, formData).then((res) => {
                    this.isLoading = false;
                    let pass = Object.assign({}, this.pass);
                    pass.document = file;
                    pass.name = res.data.type;
                    pass.permitNumber = res.data.permitNumber;
                    pass.passNumber = res.data.passNumber;
                    pass.validTo = new Date(res.data.validTo);
                    this.$refs.toastr.s("Pas is correct!");
                    this.$emit("add-pass", pass);
                }).catch(() => {
                    this.isLoading = false;
                    this.$refs.toastr.e("Onjuiste pas! Maak een betere foto.");
                });
            }  
        },
        remove(pass) {
            if(pass.document != null)
                this.passArray.splice(this.passArray.indexOf(pass), 1);
        },
    },
    validations: {
        pass: {
            name: {

            },
            color: {

            },
            document: {
                fileValidation
            }
        },
    },
    watch: {
        passes(to) {
            this.passArray = to;
        }
    }
}
</script>

<style scoped lang="scss">
.input-group-text
{
    &.grey {
        background-color: #e9ecef;
    }
    &.green {
        color: white;
        background-color: #6AB558;
    }
    &.blue {
        color: white;
        background-color: #568AC6;
    }
    &.orange {
        color: white;
        background-color: #EB6E1E;
    }
    &.yellow {
        background-color: #FFE81A;
    }
}
</style>